/**
 *
 * OCRTextPageDetectionHighlighter
 *
 */

import React, { useRef, useEffect, useState } from 'react';
import computeScrollIntoView from 'compute-scroll-into-view';
import _ from 'lodash';
import store from 'store';

// api
import { FlatInvoiceDetail } from 'lib/api/flatInvoiceDetails';

// decorate
import { decorate, Decorate, OUTLINE_SIZE, HIGHLIGHTED_PADDING } from './decorate';
import { useFormContext } from '@domonda/react-form';
import { FormValues } from 'modules/InvoiceDetail/InvoiceDetail/selectors';

export type OCRTextPageDetection = FlatInvoiceDetail;

export type OCRTextPageDetections = OCRTextPageDetection[];

interface OCRTextPageDetectionHighlighterProps {
  thresholds: {};
  scale: number;
  detection: OCRTextPageDetection;
  highlighted: boolean;
  onDetectionClick?: (detection: OCRTextPageDetection) => void;
}

const OCRTextPageDetectionHighlighter: React.FC<OCRTextPageDetectionHighlighterProps & Decorate> = (
  props,
) => {
  const { classes, scale, detection, highlighted, onDetectionClick, thresholds } = props;
  const divRef = useRef<HTMLDivElement | null>(null);
  const form = useFormContext<FormValues>();
  let scorePath = detection.Path.slice(0, detection.Path.length - 6);
  scorePath += '.Score';
  useEffect(() => {
    if (highlighted && divRef.current) {
      computeScrollIntoView(divRef.current, { scrollMode: 'if-needed' }).forEach(
        ({ el, top, left }) => {
          el.scrollTop = top;
          el.scrollLeft = left;
        },
      );
    }
  }, [highlighted, divRef.current]);
  const [isAbove, setIsAbove] = useState(false);
  const [mustHave, setMustHave] = useState(false);
  const [color, setColor] = useState('purple');

  useEffect(() => {
    const pathSeperated = detection.Path.split('.');
    const nameWithDot = [];
    for (let i = 2; i < pathSeperated.length - 1; i++) nameWithDot.push(pathSeperated[i]);
    let namePath = nameWithDot.join('.');
    if (namePath[namePath.length - 1] === ']') namePath = namePath.slice(0, namePath.indexOf('['));
    let m = mustHave;
    let above = isAbove;
    let valuePath = '';
    if (nameWithDot[0] === 'Sender' || nameWithDot[0] === 'Receiver') valuePath = namePath;
    else valuePath = detection.Type;
    if(valuePath === 'VatAmount' || valuePath === 'NetAmount' || valuePath === 'VatRate') {
      valuePath = 'VatGroup.'+valuePath;
    }
    if ((thresholds as any)[valuePath]) {
      m = true;
      setMustHave(true);
      above = _.get(form.values, scorePath) > (thresholds as any)[valuePath];
      setIsAbove(_.get(form.values, scorePath) > (thresholds as any)[valuePath]);
    }
    const c = m ? (above ? 'lightgreen' : 'orange') : 'lightgreen';
    setColor(c);
  }, [thresholds]);



  const top = detection.Y * scale;
  const left = detection.X * scale;
  const width = detection.Width * scale;
  const height = detection.Height * scale;
  store.set('scaleValue', scale);

  return (
    <div
      ref={divRef}
      onClick={onDetectionClick ? () => onDetectionClick(detection) : undefined}
      className={color === 'orange' ? classes.root + ' '+ classes.orange : classes.root}
      style={
        highlighted
          ? {
              top: top - HIGHLIGHTED_PADDING / 2,
              left: left - HIGHLIGHTED_PADDING / 2,
              width: width + HIGHLIGHTED_PADDING,
              height: height + HIGHLIGHTED_PADDING,
              opacity: 1,
              outline: `${OUTLINE_SIZE}px solid #00aae9`,
              backgroundColor: 'transparent',
            }
          : {
              top,
              left,
              width,
              height,
              backgroundColor: color,
            }
      }
    />
  );
};

const ComposedOCRTextPageDetectionHighlighter = decorate(OCRTextPageDetectionHighlighter);
export { ComposedOCRTextPageDetectionHighlighter as OCRTextPageDetectionHighlighter };
